class FooterAccordion extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.mobileMediaQuery = window.matchMedia('(max-width: 900px)')
    this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this)

    this.mobileMediaQuery.addEventListener('change', this.handleMediaQueryChange)

    this.handleMediaQueryChange(this.mobileMediaQuery)
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.mobileMediaQuery.removeEventListener('change', this.handleMediaQueryChange)
    this.teardownListeners()
  }

  handleMediaQueryChange (mq) {
    if (mq.matches) {
      this.setAriaExpanded(false)
      this.setupListeners()
    } else {
      this.setAriaExpanded(true)
      this.teardownListeners()
    }
  }

  setAriaExpanded (expanded) {
    this.setAttribute('aria-expanded', expanded)
    const contentEl = this.els.body.element
    if (expanded) {
      contentEl.style.maxHeight = `${contentEl.scrollHeight}px`
    } else {
      contentEl.style.maxHeight = 0
    }
  }

  setupListeners () {
    if (this.listenersAdded) return
    this.handleTrigger = this.handleTrigger.bind(this)
    this.els.trigger.element.addEventListener('click', this.handleTrigger)
    this.listenersAdded = true
  }

  teardownListeners () {
    if (!this.listenersAdded) return
    this.els.trigger.element.removeEventListener('click', this.handleTrigger)
    this.listenersAdded = false
  }

  handleTrigger () {
    if (!this.mobileMediaQuery.matches) return

    const currentState = this.getAttribute('aria-expanded') === 'true'
    this.setAriaExpanded(!currentState)
  }
}

if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', FooterAccordion)
}
